// extracted by mini-css-extract-plugin
export default {"searchIconWrapper":"list_searchIconWrapper__TMZwY","searchIcon":"list_searchIcon__EChns"};